import { wait } from 'cerebral/operators'
import { props, resolveObject } from 'cerebral/tags'
import createSnackbar from 'modules/App/factories/createSnackbar'
import removeSnackbar from 'modules/App/chains/removeSnackbar'
import listeningForEvent from '../factories/listeningForEvent'

export default [
  wait(100), // solves socket responding before the event gets registered
  listeningForEvent('copy'),
  {
    true: [
      ...removeSnackbar,
      ({ props, path }) => (!props.err ? path.success() : path.error),
      {
        success: [
          createSnackbar(
            resolveObject({
              key: 'bms.media.copy.completed',
              params: resolveObject({
                count: props`count`,
                nodeName: props`nodeName`
              })
            }),
            'success'
          )
        ],
        error: [
          createSnackbar(
            resolveObject({
              key: 'bms.media.errors.copying'
            }),
            'error'
          )
        ]
      }
    ],
    false: []
  }
]



// WEBPACK FOOTER //
// ./src/modules/Socket/chains/onFilesCopied.js